<template>
  <q-linear-progress :value="value / 100" :color="color" :reverse="reverse" :rounded="rounded" :size="size" :track-color="trackColor"/>
</template>

<script>
export default {
  name: 'RLinearProgress',
  props: {
    value: {
      type: Number,
      required: true,
    },
    size: String,
    color: String,
    trackColor: String,
    reverse: Boolean,
    rounded: Boolean,
  },
};
</script>
